export const CHAT_INPUT_ACTIONS = Object.freeze({
  SEND: "send",
  STOP: "stop",
  MIC: "mic",
});

export const hasComposerContent = ({
  text = "",
  attachments = [],
  attachmentCount = null,
} = {}) => {
  const textPresent = String(text || "").trim().length > 0;
  const count =
    attachmentCount == null
      ? Array.isArray(attachments) ? attachments.length : 0
      : Number(attachmentCount);

  return textPresent || (Number.isFinite(count) && count > 0);
};

export const deriveChatInputActionState = ({
  hasInputContent = false,
  loadingResponse = false,
  cancelRequested = false,
  preventQuestionInput = false,
  loadingMessages = false,
  threadViewLoading = false,
  isRecording = false,
  recordingError = "",
  preferSendWhenContentDuringResponse = false,
  allowSubmitDuringResponse = false,
} = {}) => {
  const responseInProgress = Boolean(loadingResponse && !cancelRequested);
  const inputLocked = Boolean(
    (preventQuestionInput && !responseInProgress) ||
      loadingMessages ||
      threadViewLoading,
  );
  const preventBlocksSubmit = Boolean(
    preventQuestionInput &&
      !(allowSubmitDuringResponse && responseInProgress),
  );
  const responseBlocksSubmit = Boolean(
    responseInProgress && !allowSubmitDuringResponse,
  );
  const submitLocked = Boolean(
    preventBlocksSubmit ||
      loadingMessages ||
      threadViewLoading ||
      responseBlocksSubmit,
  );

  const shouldShowSend = Boolean(
    hasInputContent &&
      (!responseInProgress || preferSendWhenContentDuringResponse),
  );
  const rightInputAction = shouldShowSend
    ? CHAT_INPUT_ACTIONS.SEND
    : responseInProgress
      ? CHAT_INPUT_ACTIONS.STOP
      : CHAT_INPUT_ACTIONS.MIC;

  const rightInputDisabled =
    rightInputAction === CHAT_INPUT_ACTIONS.STOP
      ? false
      : rightInputAction === CHAT_INPUT_ACTIONS.SEND
        ? submitLocked
        : inputLocked;

  const rightInputTooltip =
    rightInputAction === CHAT_INPUT_ACTIONS.STOP
      ? "Stop"
      : rightInputAction === CHAT_INPUT_ACTIONS.SEND
        ? "Send"
        : recordingError || (isRecording ? "Stop recording" : "Record voice");

  const rightInputAriaLabel =
    rightInputAction === CHAT_INPUT_ACTIONS.STOP
      ? "Stop generating"
      : rightInputAction === CHAT_INPUT_ACTIONS.SEND
        ? "Send message"
        : "Record audio";

  return {
    responseInProgress,
    inputLocked,
    submitLocked,
    rightInputAction,
    rightInputDisabled,
    rightInputTooltip,
    rightInputAriaLabel,
  };
};
